import { Card } from "antd";
import React from "react";

export const OrganisationProduct = (props) => {
  return (
    <Card
      hoverable
      cover={(
        <img
          src={props.product?.product_image} 
          alt={props.product?.product_name} 
          style={{ width: '100%', height: 'auto', aspectRatio: '1', objectFit: 'cover' }} 
        />
      )}
    >
      <Card.Meta
        title={props.product?.product_name}
        description={(
          <>
            <div>
              <b>{props.product?.brand}</b>
            </div>
            <p>
              {props.product?.product_description}
            </p>
          </>
        )}
      />
    </Card>
  )
};
